export const FRIENDTALK_BUTTON_OPTIONS = [
  {
    type: 'WL',
    text: 'buttonType.webLink',
  },
  {
    type: 'AL',
    text: 'buttonType.appLink',
  },
  {
    type: 'AC',
    text: 'buttonType.addChannel',
  },
  {
    type: 'BF',
    text: 'buttonType.businessForm',
  },
  {
    type: 'BK',
    text: 'buttonType.botKeyword',
  },
];

export const FRIENDTALK_BUTTON_TYPES = FRIENDTALK_BUTTON_OPTIONS.map(({ type }) => type);

export const LINK_MAX_LENGTH = 2000;

export const BRAND_LINK_MAX_LENGTH = 1_000;

export const CONTENT_MAX_BYTES = 2000;

// titleSuffix: 카카오는 쿠폰 title 을 한글 형식 5종만 허용하므로 UI 언어와 상관없이 이 값으로 만든다
// (배송비 할인 쿠폰은 쿠폰명 없이 titleSuffix 가 title 전체)
export const COUPON_TYPE_OPTIONS = [
  {
    text: 'couponType.numberDiscount',
    type: 'NUMBER_DISCOUNT',
    titleSuffix: '원 할인 쿠폰',
  },
  {
    text: 'couponType.percentDiscount',
    type: 'PERCENT_DISCOUNT',
    titleSuffix: '% 할인 쿠폰',
  },
  {
    text: 'couponType.deliveryDiscount',
    type: 'DELIVERY_DISCOUNT',
    titleSuffix: '배송비 할인 쿠폰',
  },
  {
    text: 'couponType.freeCoupon',
    type: 'FREE_COUPON',
    titleSuffix: ' 무료 쿠폰',
  },
  {
    text: 'couponType.upCoupon',
    type: 'UP_COUPON',
    titleSuffix: ' UP 쿠폰',
  },
];

export const COUPON_TYPE_INFO = {
  NUMBER_DISCOUNT: {
    namePlaceholder: 'placeholder.coupon.NUMBER_DISCOUNT',
    nameDisabled: false,
  },
  PERCENT_DISCOUNT: {
    namePlaceholder: 'placeholder.coupon.PERCENT_DISCOUNT',
    nameDisabled: false,
  },
  DELIVERY_DISCOUNT: {
    namePlaceholder: 'placeholder.coupon.DELIVERY_DISCOUNT',
    nameDisabled: true,
  },
  FREE_COUPON: {
    namePlaceholder: 'placeholder.coupon.FREE_COUPON',
    nameDisabled: false,
  },
  UP_COUPON: {
    namePlaceholder: 'placeholder.coupon.UP_COUPON',
    nameDisabled: false,
  },
};

export const COUPON_TYPES = COUPON_TYPE_OPTIONS.map(({ type }) => type);

export const MESSAGE_TYPE_TO_NAME_MAX = {
  // 캐러셀 피드, 캐러셀 커머스 버튼 이름(버튼이 있는 경우 필수, 최대 8자)
  // 버튼 이름(최대 28자, 와이드 아이템 리스트일 경우, 9자)
  // FRIENDTALK_TEXT: 28,
  // FRIENDTALK_IMAGE: 28,
  // FRIENDTALK_WIDE_IMAGE: 28,
  // FRIENDTALK_WIDE_ITEM_LIST: 9,
  // FRIENDTALK_COMMERCE: 28,
  // FRIENDTALK_CAROUSEL_FEED: 8,
  // FRIENDTALK_CAROUSEL_COMMERCE: 8,
  // FRIENDTALK_PREMIUM_VIDEO: 28,
  FRIENDTALK_TEXT: 14,
  FRIENDTALK_IMAGE: 14,
  FRIENDTALK_WIDE_IMAGE: 8,
  FRIENDTALK_WIDE_ITEM_LIST: 8,
  FRIENDTALK_COMMERCE: 8,
  FRIENDTALK_CAROUSEL_FEED: 8,
  FRIENDTALK_CAROUSEL_COMMERCE: 8,
  FRIENDTALK_PREMIUM_VIDEO: 8,
  // - TEXT, IMAGE 타입일 경우 최대 14자
  // - 이외의 타입일 경우 최대 8자
  BRANDTALK_TEXT: 14,
  BRANDTALK_IMAGE: 14,
  BRANDTALK_WIDE_IMAGE: 8,
  BRANDTALK_WIDE_ITEM_LIST: 8,
  BRANDTALK_COMMERCE: 8,
  BRANDTALK_CAROUSEL_FEED: 8,
  BRANDTALK_CAROUSEL_COMMERCE: 8,
  BRANDTALK_PREMIUM_VIDEO: 8,
};

// 메세지 타입별 쿠폰 description validate (max length)
export const MESSAGE_TYPE_TO_COUPON_DESCRIPTION_INFO = {
  FRIENDTALK_TEXT: {
    maxLength: 12,
  },
  FRIENDTALK_IMAGE: {
    maxLength: 12,
  },
  FRIENDTALK_WIDE_IMAGE: {
    maxLength: 18,
  },
  FRIENDTALK_WIDE_ITEM_LIST: {
    maxLength: 18,
  },
  FRIENDTALK_COMMERCE: {
    maxLength: 12,
  },
  FRIENDTALK_CAROUSEL_FEED: {
    maxLength: 12,
  },
  FRIENDTALK_CAROUSEL_COMMERCE: {
    maxLength: 12,
  },
  FRIENDTALK_PREMIUM_VIDEO: {
    // maxLength: 12,
    maxLength: 18,
  },
  BRANDTALK_TEXT: {
    maxLength: 12,
  },
  BRANDTALK_IMAGE: {
    maxLength: 12,
  },
  BRANDTALK_WIDE_IMAGE: {
    maxLength: 18,
  },
  BRANDTALK_WIDE_ITEM_LIST: {
    maxLength: 18,
  },
  BRANDTALK_CAROUSEL_FEED: {
    maxLength: 12,
  },
  BRANDTALK_CAROUSEL_COMMERCE: {
    maxLength: 12,
  },
  BRANDTALK_COMMERCE: {
    maxLength: 12,
  },
  BRANDTALK_PREMIUM_VIDEO: {
    maxLength: 18,
  },
};

export const RIGHT_PANEL_WIDTH = 430;

export const MESSAGE_TYPE_TO_BUTTONS_COUPON_LENGTH = {
  FRIENDTALK_TEXT: {
    buttons: {
      max: 5,
    },
    coupon: 1,
    total: 5,
  },
  FRIENDTALK_IMAGE: {
    buttons: {
      max: 5,
    },
    coupon: 1,
    total: 5,
  },
  FRIENDTALK_WIDE_IMAGE: {
    buttons: {
      max: 2,
    },
    coupon: 1,
    total: 3,
  },
  FRIENDTALK_WIDE_ITEM_LIST: {
    buttons: {
      max: 2,
    },
    coupon: 1,
    total: 3,
  },
  FRIENDTALK_COMMERCE: {
    buttons: {
      max: 2,
      min: 1,
    },
    coupon: 1,
    total: 3,
  },
  FRIENDTALK_CAROUSEL_FEED: {
    buttons: {
      max: 2,
      min: 1,
    },
    coupon: 1,
    total: 3,
  },
  FRIENDTALK_CAROUSEL_COMMERCE: {
    buttons: {
      max: 2,
      min: 1,
    },
    coupon: 1,
    total: 3,
  },
  FRIENDTALK_PREMIUM_VIDEO: {
    buttons: {
      max: 1,
    },
    coupon: 1,
    total: 2,
  },
  BRANDTALK_TEXT: {
    buttons: {
      max: 5,
    },
    coupon: 1,
    total: 5,
  },
  BRANDTALK_IMAGE: {
    buttons: {
      max: 5,
    },
    coupon: 1,
    total: 5,
  },
  BRANDTALK_WIDE_IMAGE: {
    buttons: {
      max: 2,
    },
    coupon: 1,
    total: 3,
  },
  BRANDTALK_WIDE_ITEM_LIST: {
    buttons: {
      max: 2,
    },
    coupon: 1,
    total: 3,
  },
  BRANDTALK_COMMERCE: {
    buttons: {
      max: 2,
      min: 1,
    },
    coupon: 1,
    total: 3,
  },
  BRANDTALK_CAROUSEL_FEED: {
    buttons: {
      max: 2,
      min: 1,
    },
    coupon: 1,
    total: 3,
  },
  BRANDTALK_CAROUSEL_COMMERCE: {
    buttons: {
      max: 2,
      min: 1,
    },
    coupon: 1,
    total: 3,
  },
  BRANDTALK_PREMIUM_VIDEO: {
    buttons: {
      max: 1,
    },
    coupon: 1,
    total: 2,
  },
};

export const FRIENDTALK_DB_MAX_LENGTH = {
  content: 1500,
  additionalContent: 50,
  buttons: {
    name: 100,
  },
  intro: {
    header: 50,
    content: 100,
  },
  commerce: {
    title: 100,
    regularPrice: 20,
    discountPrice: 20,
    discountRate: 20,
    discountFixed: 20,
  },
  feed: {
    header: 50,
    content: 300,
  },
  wideItemList: {
    header: 50,
    content: 50,
  },
  premiumVideo: {
    header: 50,
    content: 1500,
  },
};

export const ROUTE_TO_ACCEPT_MESSAGE_TYPES = {
  message: [
    'SMS',
    'LMS',
    'MMS',
  ],
  kakao: [
    'FRIENDTALK_TEXT',
    'FRIENDTALK_IMAGE',
    'FRIENDTALK_WIDE_IMAGE',
    'FRIENDTALK_WIDE_ITEM_LIST',
    'FRIENDTALK_COMMERCE',
    'FRIENDTALK_CAROUSEL_FEED',
    'FRIENDTALK_CAROUSEL_COMMERCE',
    'FRIENDTALK_PREMIUM_VIDEO',
  ],
  alimtalk: [
    'ALIMTALK_BA',
    'ALIMTALK_EX',
    'ALIMTALK_AD',
    'ALIMTALK_MI',
  ],
  brand: [
    'BRANDTALK_TEXT',
    'BRANDTALK_IMAGE',
    'BRANDTALK_WIDE_IMAGE',
    'BRANDTALK_WIDE_ITEM_LIST',
    'BRANDTALK_CAROUSEL_FEED',
    'BRANDTALK_CAROUSEL_COMMERCE',
    'BRANDTALK_COMMERCE',
    // 'BRANDTALK_PREMIUM_VIDEO',
  ],
};

export const BUSINESS_FORM_OPTIONS = [
  {
    text: 'buttonType.businessFormOptions.surveys',
    value: '톡에서 설문하기',
  },
  {
    text: 'buttonType.businessFormOptions.applications',
    value: '톡에서 응모하기',
  },
  {
    text: 'buttonType.businessFormOptions.reservations',
    value: '톡에서 예약하기',
  },
];

export const DISALLOWED_VARIABLE_NAMES = [
  '할인금액',
  '할인율',
  '상품명',
  '정상가격',
  '할인가격',
  '정액할인가격',
];
